import { Token } from "../../../app/models/common/types";

export const fonts:{ [key: string]: string } = {
    "Gotham Medium": "Gotham-Medium",
    "Gotham Book": "Gotham-Book",
    "Gotham Bold": "Gotham-Bold",
    "Gotham Black": "Gotham-Black",
    "Gotham Light":"Gotham-Light",
    "Droid Serif Bold": "DroidSerif700",
    "Droid Serif Italic": "DroidSerif-Italic",
    "Droid Serif Regular": "DroidSerif-Regular",
    "Droid Serif Bold Italic": "DroidSerif-BoldItalic",
    "Montserrat": "Montserrat",
    "Georgia": "georgia",
}

const fontTokens: Token[] = [];

for (const font in fonts) {
    fontTokens.push({
        name: font,
        value: fonts[font]
    });
}

export default fontTokens;